import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-page__statistics" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__delimiter" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "n-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"]),
    _hoisted_2,
    _createVNode(_component_SortDropdown, {
      items: _ctx.sortTypes,
      modelValue: _ctx.module.filter.current.ordering,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event)),
      pin: _ctx.pin,
      "pin-key": _ctx.module.name
    }, null, 8, ["items", "modelValue", "pin", "pin-key"]),
    _hoisted_3,
    _renderSlot(_ctx.$slots, "after")
  ]))
}